import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import PropTypes from 'prop-types';
import { useState } from 'react';

import isEmpty from 'lodash.isempty';
import { useNotificationStore } from '../../../stores/notificationStore';

const ChallengeQuestions = ({ user, onSave = () => {} }) => {
	const { showSuccess, showError } = useNotificationStore();
	const [question1, setQuestion1] = useState(-1);
	const [question2, setQuestion2] = useState(-1);
	const [question3, setQuestion3] = useState(-1);
	const [answer1, setAnswer1] = useState('');
	const [answer2, setAnswer2] = useState('');
	const [answer3, setAnswer3] = useState('');

	const query = useQuery({
		queryKey: ['questions'],
		queryFn: async () => {
			const { data } = await axios.get('/clients/security-questions');
			return data;
		},
	});

	const handleSaveQuestionAndResponses = async (event) => {
		event.preventDefault();
		const security_questions = [
			{ question_id: question1, answer: answer1 },
			{ question_id: question2, answer: answer2 },
			{ question_id: question3, answer: answer3 },
		];
		try {
			await axios.post(`/clients/${user.id}/security-questions-save`, {
				security_questions,
			});
			showSuccess('Challenge questions updated');
			// clear fields
			setQuestion1(-1);
			setQuestion2(-1);
			setQuestion3(-1);
			setAnswer1('');
			setAnswer2('');
			setAnswer3('');
			onSave();
		} catch (err) {
			showError('Unable to save your choices');
		}
	};

	const questionSet1 = query.data?.filter(
		({ id }) => id != question2 && id != question3,
	);
	const questionSet2 = query.data?.filter(
		({ id }) => id != question1 && id != question3,
	);
	const questionSet3 = query.data?.filter(
		({ id }) => id != question1 && id != question2,
	);

	if (!query.data) {
		return null;
	}

	return (
		<form className="bg-white shadow-sm card ring-1 ring-gray-900/5 md:col-span-2">
			<div className="card-body">
				<div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
					<div className="form-control sm:col-span-4">
						<label htmlFor="question1" className="label label-text">
							Question 1
						</label>
						<select
							id="question1"
							name="question1"
							required
							className="select select-bordered select-sm"
							onChange={({ target }) => setQuestion1(target.value)}
							value={question1}
						>
							<option value={-1}>Choose...</option>
							{questionSet1.map(({ id, question }) => (
								<option key={`${id}`} value={id}>
									{question}
								</option>
							))}
						</select>
					</div>
					<div className="form-control sm:col-span-6">
						<label htmlFor="answer1" className="label label-text">
							Answer 1
						</label>
						<input
							id="answer1"
							name="answer1"
							type="text"
							required
							className="input input-sm input-bordered"
							onChange={({ target }) => setAnswer1(target.value)}
							value={answer1}
						/>
					</div>
					<div className="form-control sm:col-span-4">
						<label htmlFor="question2" className="label label-text">
							Question 2
						</label>
						<select
							id="question2"
							name="question2"
							required
							className="select select-bordered select-sm"
							onChange={({ target }) => setQuestion2(target.value)}
							value={question2}
						>
							<option value={-1}>Choose...</option>
							{questionSet2.map(({ id, question }) => (
								<option key={`${id}`} value={id}>
									{question}
								</option>
							))}
						</select>
					</div>
					<div className="form-control sm:col-span-6">
						<label htmlFor="answer2" className="label label-text">
							Answer 2
						</label>
						<input
							id="answer2"
							name="answer2"
							type="text"
							required
							className="input input-sm input-bordered"
							onChange={({ target }) => setAnswer2(target.value)}
							value={answer2}
						/>
					</div>
					<div className="form-control sm:col-span-4">
						<label htmlFor="question3" className="label label-text">
							Question 3
						</label>
						<select
							id="question3"
							name="question3"
							required
							className="select select-bordered select-sm"
							onChange={({ target }) => setQuestion3(target.value)}
							value={question3}
						>
							<option value={-1}>Choose...</option>
							{questionSet3.map(({ id, question }) => (
								<option key={`${id}`} value={id}>
									{question}
								</option>
							))}
						</select>
					</div>
					<div className="form-control sm:col-span-6">
						<label htmlFor="answer3" className="label label-text">
							Answer 3
						</label>
						<input
							id="answer3"
							name="answer3"
							type="text"
							required
							className="input input-sm input-bordered"
							onChange={({ target }) => setAnswer3(target.value)}
							value={answer3}
						/>
					</div>
				</div>
			</div>
			<div className="justify-end px-8 py-4 border-t card-actions border-gray-900/10">
				<button
					className="text-white btn btn-primary btn-sm"
					name="form"
					value="challQuestions"
					disabled={
						query.isPending ||
						query.isError ||
						question1 == -1 ||
						question2 == -1 ||
						question3 == -1 ||
						isEmpty(answer1) ||
						isEmpty(answer2) ||
						isEmpty(answer3)
					}
					onClick={handleSaveQuestionAndResponses}
				>
					Save
				</button>
			</div>
		</form>
	);
};

ChallengeQuestions.propTypes = {
	user: PropTypes.object.isRequired,
	onSave: PropTypes.func,
};

export default ChallengeQuestions;
